export const LANGUAGE_OPTIONS = [
  {value: "en-US", label: "English (US)"},
  {value: "pt-BR", label: "Portugues (Brasil)"},
  {value: "es-ES", label: "Espanol (Espana)"},
  {value: "fr-FR", label: "Francais (France)"},
  {value: "de-DE", label: "Deutsch (Deutschland)"},
];

export const COUNTRY_OPTIONS = [
  {value: "US", label: "United States"},
  {value: "BR", label: "Brasil"},
  {value: "PT", label: "Portugal"},
  {value: "ES", label: "Espana"},
  {value: "FR", label: "France"},
  {value: "DE", label: "Deutschland"},
  {value: "MX", label: "Mexico"},
  {value: "AR", label: "Argentina"},
  {value: "GB", label: "United Kingdom"},
];

export const normalizeLanguage = language => {
  const fallback = "en-US";
  if (!language) return fallback;

  const normalized = String(language).trim().replace(/_/g, "-");
  const [baseLanguage, region] = normalized.split("-");

  if (!baseLanguage) return fallback;

  return region
    ? `${baseLanguage.toLowerCase()}-${region.toUpperCase()}`
    : baseLanguage.toLowerCase();
};

export const normalizeCountry = (country, language) => {
  if (country) {
    return String(country).trim().slice(0, 2).toUpperCase();
  }

  const regionFromLanguage = normalizeLanguage(language).split("-")[1];
  return regionFromLanguage || "US";
};

export const getRegionalPreferences = ({language, country} = {}) => {
  const browserLanguage =
    (typeof navigator !== "undefined" &&
      (navigator.languages?.find(Boolean) || navigator.language)) ||
    (typeof Intl !== "undefined" &&
      Intl.DateTimeFormat().resolvedOptions().locale) ||
    "en-US";

  const resolvedLanguage = normalizeLanguage(language || browserLanguage);
  const resolvedCountry = normalizeCountry(country, resolvedLanguage);

  return {
    language: resolvedLanguage,
    country: resolvedCountry,
  };
};

